/* dev/assets/js/a-gdpr.js */
function setCookie(name, value, expiryDays, domain, path) {
  var exdate = new Date();
  exdate.setDate(exdate.getDate() + (expiryDays || 365));

  var cookie = [
    name + "=" + value,
    "expires=" + exdate.toUTCString(),
    "path=" + (path || "/")
  ];

  document.cookie = cookie.join(";");
}

(function ($) {
  "use strict";
  $(function () {
    $.cookieSettings = Cookies.get("DONEGDPRConsent");

    if ($.cookieSettings != undefined) {
      $.cookieSettings = JSON.parse($.cookieSettings);
    } else {
      setCookie("DONEGDPRConsent", JSON.stringify({ functional: true, performance: true, targeting: true }), 365);
      $(".done-gdpr-alert-box-wrapper").addClass("active");
      $.cookieSettings = Cookies.get("DONEGDPRConsent");
      $.cookieSettings = JSON.parse($.cookieSettings);
    }

    $(document).on("click", ".js-open-cookie a,#done-gdpr-toggle-display", function (e) {
      e.preventDefault();
      cookiedone.showCookieSettings();

      if ($.cookieSettings != undefined && $.cookieSettings.performance == true) {
        $(".done-gdpr-status-checkbox.performance").attr("checked", true);
      }
      if ($.cookieSettings != undefined && $.cookieSettings.functional == true) {
        $(".done-gdpr-status-checkbox.functional").attr("checked", true);
      }
      if ($.cookieSettings != undefined && $.cookieSettings.targeting == true) {
        $(".done-gdpr-status-checkbox.targeting").attr("checked", true);
      }
    }
    );

    $(document).on("click", "#done-gdpr-save-button", function (e) {
      location.reload();
    });

    $(document).on("click", ".done-gdpr-button-allow", function (e) {
      e.preventDefault();
      e.stopPropagation();
      cookiedone.allowAll();
      location.reload();
    });
  });
})(jQuery);
